import React from 'react';
import {PropTypes} from 'prop-types';
import moment from 'moment-timezone';
import {BaseFormComponent} from '../../shared/baseFormComponent';
import {InfoItem} from '../AccountInfo/infoitem';
import {AccountComponent} from '../AccountsListComponent/account';
import {PageHeader} from '../../shared/PageHeader';
import {DateTimePicker} from '../../shared/TimePicker';
import {MakeApiCall, WriteConsoleErrors, GoBackOrRoot} from '../../shared/utils';

import './styles.scss';
import {ButtonBusyIndicatorComponent} from '../../shared/buttonBusyIndicatorComponent';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';
import { Checkbox } from '../../shared/checkbox';

const KBARTICLE_ACTION = {
    NONE: 0,
    SAVE: 1
}

export class KBArticleEditFormComponent extends BaseFormComponent {
    constructor(props, ...others) {
        super(props, ...others);

        this.state = {
            errors: null,
            action: KBARTICLE_ACTION.NONE,
            formData: {
                Id: null, 
                ErrorId: '', 
                Title: '', 
                Url: '', 
                SendNotifications: true,
                ...props.articleData
            },
        }

        this._valueHandler.onChangeOptions = {
            'ErrorId': {doLTrim: true},
            'Title': {doLTrim: true},
            'Url': {doLTrim: true},
        }
        this._valueHandler.onBlurOptions = {
            'ErrorId': {doLTrim: true, doRTrim: true},
            'Title': {doLTrim: true, doRTrim: true},
            'Url': {doLTrim: true, doRTrim: true},
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.doSave = this.doSave.bind(this);
        this.doCancel = this.doCancel.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleSubmit(e) {
        e.preventDefault();
        this.doSave();
    }

    handleCancelClick() {
        this.doCancel();
    }

    doSave() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const {verificationToken} = self.props;
        const {formData} = self.state;

        const data = {...formData};

        new Promise(resolve => {
            self.setState({action: KBARTICLE_ACTION.SAVE}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.post(
                        {
                            url: '/api/admin/saveKBArticle',
                            headers: {RequestVerificationToken: verificationToken},
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    )
                )
            }
            return null;
        })
        .then(self.doCancel)
        .catch(errors => {
            if (self._isMounted) {
                self.setState({action: KBARTICLE_ACTION.NONE, errors: errors});
                WriteConsoleErrors(errors, true, true);
            }
        });
    }

    doCancel() {
        if (this._isMounted) {
            GoBackOrRoot();
        }
    }

    render() {
        const self = this;
        const {action, formData, errors} = self.state;

        const isDisabled = action != KBARTICLE_ACTION.NONE;
        const isNew = isNaN(parseInt(formData.Id));

        return (
            <div>
                <PageHeader
                    fixed
                    captionTruncate
                    notWrappedMaxHeight={75}
                    caption={
                        <h2 className="text-truncate">Knowledge Base Article</h2>
                    }
                />

                <form onSubmit={self.handleSubmit}>
                    <div className="form-group newstyle">
                        <input 
                            id="ErrorId" 
                            name="ErrorId" 
                            type="text" 
                            className={self.getControlClass('ErrorId', errors, 'form-control')}
                            disabled={isDisabled}
                            maxLength={32} 
                            value={formData.ErrorId || ''} 
                            readOnly={!isNew}
                            style={{maxWidth: '22em'}}
                            onChange={self.handleInputChange}
                            onBlur={self.handleInputChange}
                        />
                        <label htmlFor="ErrorId"><span className="text-truncate">Error Id</span></label>
                        <div className="invalid-feedback">{self.getControlError('ErrorId', errors)}</div>
                    </div>
                    <div className="form-group newstyle">
                        <input 
                            id="Title" 
                            name="Title" 
                            type="text" 
                            className={self.getControlClass('Title', errors, 'form-control')}
                            disabled={isDisabled}
                            value={formData.Title || ''} 
                            onChange={self.handleInputChange}
                            onBlur={self.handleInputChange}
                        />
                        <label htmlFor="Title"><span className="text-truncate">Title</span></label>
                        <div className="invalid-feedback">{self.getControlError('Title', errors)}</div>
                    </div>
                    <div className="form-group newstyle">
                        <input 
                            id="Url" 
                            name="Url" 
                            type="text" 
                            className={self.getControlClass('Url', errors, 'form-control')}
                            disabled={isDisabled}
                            value={formData.Url || ''} 
                            onChange={self.handleInputChange}
                            onBlur={self.handleInputChange}
                        />
                        <label htmlFor="Url"><span className="text-truncate">Url</span></label>
                        <div className="invalid-feedback">{self.getControlError('Url', errors)}</div>
                    </div>
                    <div className="form-group newstyle">
                        <Checkbox 
                            id="SendNotifications"
                            name="SendNotifications"
                            checked={formData.SendNotifications}
                            onChange={self.handleInputChange} 
                            disabled={isDisabled}
                            label={
                                <span className="text-secondary">Send notifications to developers <span className="fs-sm">(ignored if Url is specified)</span></span>
                            }
                        />
                    </div>

                    <ErrorsBlockComponent errors={errors} excludedErrors="PaymentTypeId TransactionId Amount Fee" unstyled />

                    <div className="form-buttons pt-3">
                        <button
                            type="submit"
                            disabled={isDisabled}
                            className="btn btn-sm btn-primary newstyle"
                        >
                            {isNew ? 'Create article' : 'Save changes'}
                            <ButtonBusyIndicatorComponent visible={action == KBARTICLE_ACTION.SAVE} />
                        </button>
                        <button
                            type="button"
                            disabled={isDisabled}
                            className="btn btn-sm btn-outline-secondary newstyle"
                            onClick={self.handleCancelClick}
                        >
                            Cancel
                        </button>
                    </div>

                </form>
            </div>
        )
    }
}
KBArticleEditFormComponent.propTypes = {
    articleData: PropTypes.shape({Id: PropTypes.number, ErrorId: PropTypes.string, Title: PropTypes.string, Url: PropTypes.string})
}
